import { Component, Input } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
    selector: 'ajs-fa-icon-tooltip',
    templateUrl: './ajs-fa-icon-tooltip.component.html',
    standalone: true,
    imports: [MatTooltipModule],
})
export class AjsFaIconTooltipComponent {
	/**
	 * Text to display when fa icon is hovered over.
	 */
	@Input() toolTipText?: string;

	/**
	 * above | below | left | right | before | after
	 */
	@Input()
	toolTipPosition?: string;

	/**
	 * Examples:  for a font awesome blue info icon = "fa fa-lg fa-info-circle blueImage"
	 */
	@Input()
	iClass?: string;
}
